<app-programtitle title="Budget calculator"></app-programtitle>
<p> Write a program to calculate budget given monthly income and expenses.</p>

<app-editor code="{{program}}"> </app-editor>